import { render, staticRenderFns } from "./AddLessonsToLanguage.vue?vue&type=template&id=66251442"
import script from "./AddLessonsToLanguage.vue?vue&type=script&lang=js"
export * from "./AddLessonsToLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports